<template>
  <div class="invitacion-container">

    <!-- 🎥 VIDEO DE FONDO OPTIMIZADO -->
    <video
      class="video-fondo"
      autoplay
      muted
      loop
      playsinline
      webkit-playsinline
      preload="auto"
      disablePictureInPicture
      data-ke-video="true"
    >
      <source src="@/assets/vv1.mp4" type="video/mp4" />
    </video>

    <!-- 🌸 CARD ENCIMA DEL VIDEO -->
    <div class="invitacion-card">

      <img src="@/assets/coroa.png" class="sello-decorativo" />
      <img src="@/assets/coroa.png" class="sello-decorativo sello-secundario" />

      <h1 ref="titulo" class="titulo-principal"></h1>

      <p ref="nombres" class="subtitulo">
        <br />        Heaven

      </p>

      <p ref="fecha" class="fecha">Noviembre • 07 • 2026</p>

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion">Por favor, selecciona tu idioma</p>

        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            Español
          </button>
          <button 
            @click="seleccionar('en')" 
            class="btn-idioma"
          >
            English
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null);
    const ramaDerecha = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const ampersand = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.from(ramaIzquierda.value, {
        x: -200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
      });

      gsap.from(ramaDerecha.value, {
        x: 200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        delay: 0.3,
      });

      // Animación de entrada escalonada
      gsap.timeline({ delay: 0.5 })
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        })
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(ampersand.value, {
          scale: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)',
        }, '-=1')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      titulo,
      nombres,
      ampersand,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

/* ===== CONTENEDOR ===== */
.invitacion-container{
  position: relative;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 20px;
}

/* ===== VIDEO DE FONDO ===== */
.video-fondo{
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  filter: brightness(0.75) saturate(1.1);
  /* Quitar cualquier sombra o borde que el navegador ponga por defecto */
  outline: none;
  border: none;
}

/* ===== CARD ===== */
.invitacion-card{
  position: relative;
  z-index: 5;

  width: 100%;
  max-width: 340px; 
  min-width: 280px;

  padding: clamp(50px, 6vw, 70px) 18px clamp(50px, 6vw, 60px);
  border-radius: 0 60px 0 60px;

  text-align: center;

  background: linear-gradient(
    rgba(236, 231, 208, 0.92),
    rgba(143, 136, 104, 0.779)
  );

  backdrop-filter: blur(2px);

  box-shadow:
    0 18px 50px rgba(0,0,0,.25),
    0 6px 14px rgba(0,0,0,.15);
}

/* ===== SELLO ===== */
.sello-decorativo{
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%) rotate(-1.5deg);

  width: clamp(190px, 35vw, 270px);
  z-index: 6;
  opacity: 0.9;

  filter:
    drop-shadow(0 10px 18px rgba(0,0,0,0.25))
    saturate(0.85)
    brightness(1.05);

  pointer-events: none;
}

.sello-secundario{
  opacity: 0.5;
}

/* ===== TITULO ===== */
.titulo-principal{
  font-family: 'Dancing Script', cursive;
  font-size: clamp(1.8rem, 5vw, 2.3rem);
  color: #ffffff;
}

/* ===== NOMBRE ===== */
.subtitulo{
  font-family: 'CynthiaJuneJF', serif;
  font-size: clamp(4.2rem, 9vw, 6.2rem) !important;
  margin-top: -45px;
  font-weight: 500;
  color:#fffdfd;
}

/* ===== FECHA ===== */
.fecha{
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1rem, 3vw, 1.2rem);
  color: #ffffff;
  margin-bottom: 1.5rem;
}

/* ===== IDIOMAS ===== */
.seccion-idiomas{
  margin-top: 1.8rem;
}

.instruccion{
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: #ffffff;
  margin-bottom: 1.2rem;
}

.opciones-idioma{
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.btn-idioma{
  padding: 12px;
  border-radius: 14px;
  border: 1px solid #ece5e7;
  background: #ffffff;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: .3s;
  color:rgb(45, 63, 56);

  font-size: clamp(0.9rem, 2.5vw, 1rem);
}

.btn-idioma:hover{
  transform: translateY(-2px);
  background: #f7eaea;
}

/* ===== RESPONSIVE EXTRA ===== */
@media(max-width:380px){
  .invitacion-card{
    max-width: 90%;
    border-radius: 0 50px 0 50px;
  }
}
</style>